<div [@inOutAnimation] class="pwa-prompt">
  <div class="app-icon">
    <img alt="Приложение {{ appName }}" [src]="appLogo" />
  </div>
  <a (click)="startPwaInstallation()" class="pwa-prompt-message">
    Установите приложение <span class="app-name">{{ appName }}</span>
  </a>
  <i (click)="closePwaPrompt($event)" class="icon-close"></i>
</div>
